var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateFailGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 21.1",
    style: {
      enableBackground: "new 0 0 22 21.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#9A9A9A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.9,19.9l-4-4.4c-0.6-0.6-1-1.5-0.9-2.4v-5c-0.1-0.9,0.3-1.8,0.9-2.4l4-4.4C5.6,0.4,6.6-0.1,7.7,0h6.6 c1.1-0.1,2.1,0.4,2.8,1.2l4,4.4c0.6,0.6,1,1.5,0.9,2.4v5c0.1,0.9-0.3,1.8-0.9,2.4l-4,4.4c-0.7,0.8-1.7,1.3-2.8,1.2H7.7 C6.6,21.2,5.6,20.7,4.9,19.9z M12.2,15c0-0.7-0.6-1.2-1.2-1.2c0,0,0,0,0,0c-0.7,0-1.2,0.6-1.1,1.2c0,0.6,0.6,1.2,1.2,1.1 C11.7,16.1,12.2,15.6,12.2,15z M11.9,11.2l0.2-5.4c0-0.6-0.4-1-1-1c0,0-0.1,0-0.1,0c-0.5,0-1,0.4-1,0.9c0,0,0,0.1,0,0.1l0.1,5.4 c0,0.5,0.3,0.9,0.8,0.9c0,0,0.1,0,0.1,0c0.5,0,0.9-0.3,0.9-0.8C11.9,11.3,11.9,11.3,11.9,11.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.749 4.768)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,7.5c0.5,0,0.9-0.3,0.9-0.8c0,0,0-0.1,0-0.1l0.2-5.5c0-0.6-0.4-1-1-1.1c0,0-0.1,0-0.1,0 c-0.6,0-1,0.4-1.1,0.9c0,0,0,0.1,0,0.1l0.2,5.5c0,0.5,0.3,0.9,0.8,0.9C1.1,7.5,1.2,7.5,1.3,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.3,11.6c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C0.5,9.2,0,9.7,0,10.4C0,11,0.6,11.6,1.3,11.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateFailGray);
export default __webpack_public_path__ + "static/media/UpdateFailGray.8351fcea31ec81d1e6848c35dc15bdae.svg";
export { ForwardRef as ReactComponent };